import { notification } from 'antd';
import { remove } from 'lodash';

import { areAllFieldsEmpty } from '@/src/search/utils';
import { convertMomentToDate } from '@/utils/dateTimeHelpers';
import { addTransformUtils } from '@/utils/formHelpers';

const search = (values, searchOptions) => {
  const _values = { ...values };
  const copyFieldOptions = addTransformUtils(_values, searchOptions);
  const payload = {
    SearchId: null,
    PersonId: 0,
    FullName: null,
    SearchDescription: null,
    FieldOptions: {
      SearchText: _values.SearchText,
      States: copyFieldOptions.getFullComplex('States', 'StateCode'),
      Charts: copyFieldOptions.getFullComplex('Charts', 'ChartId'),
      Categories: _values.Categories ? [{ CategoryId: _values.Categories }] : [],
      DateStart: Array.isArray(_values.DateRanges) && convertMomentToDate(_values.DateRanges[0]),
      DateEnd: Array.isArray(_values.DateRanges) && convertMomentToDate(_values.DateRanges[1]),
      PageSize: null,
      SortField: null,
      SortOrder: null,
      Page: null,
    },
  };

  return payload;
};

const saveSearch = ({ values, form, options, initialData }) => {
  if (areAllFieldsEmpty(form)) {
    notification.error({
      message: 'Search',
      description: 'Search option is required.',
    });
    return;
  }

  const _values = { ...values };
  const copyFieldOptions = addTransformUtils(_values.FieldOptions, options);
  const payload = {
    ...initialData,
    ..._values,
    FieldOptions: {
      ...initialData.FieldOptions,
      States: copyFieldOptions.getFullComplex('States', 'StateCode'),
      Charts: copyFieldOptions.getFullComplex('Charts', 'ChartId'),
      Categories: _values.FieldOptions.Category
        ? [{ CategoryId: _values.FieldOptions.Category }]
        : [],
    },
  };

  // eslint-disable-next-line consistent-return
  return payload;
};

const isSearchFiltersEmpty = form => {
  const { getFieldsValue } = form;
  const fieldsValues = getFieldsValue();
  const _copy = { ...fieldsValues };

  // eslint-disable-next-line compat/compat
  const values = Object.values(_copy);

  remove(values, field => {
    if (Array.isArray(field)) {
      if (field.length < 1) {
        return true;
      }
    } else if (!field) {
      return true;
    }
    return false;
  });

  return values.length < 1;
};
export { search, saveSearch, isSearchFiltersEmpty };
